import { render } from "./TheDetailedSearch.vue?vue&type=template&id=2a017360&scoped=true&ts=true"
import script from "./TheDetailedSearch.vue?vue&type=script&lang=ts"
export * from "./TheDetailedSearch.vue?vue&type=script&lang=ts"

import "./TheDetailedSearch.vue?vue&type=style&index=0&id=2a017360&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a017360"]])

export default __exports__